export default __webpack_public_path__ + "5a4907ac637f1f124a2a8a8a0a9d5988.svg";